import { get } from "../../utils/object-helpers";

$ {
    const EDIT_MAX_LENGTH = 1000;
    const EDIT_ROWS = 4;
    const title = get(input, "title", {});
    const sections = get(input, "sections", []);
    const profileEditState = get(input, "globalState.profileEdit", {});
    const descriptionText = get(state, "about.textSpans.0.text", "");
    const descriptionClasses = ["str-about-description__about-intro"];
    if (profileEditState.editing) descriptionClasses.push("editing");
    if (!profileEditState.editing && !descriptionText) descriptionClasses.push("hide")
}

<div class="str-about-description about-layout--gutters">
    <str-title ...title />
    <section class=`${descriptionClasses.join(" ")}`>
        <div class="str-about-description__description" data-test-id="about-description">
            <if(profileEditState?.editing)>
                <div class="str-about-description__edit-wrapper">
                    <span class="str-about-description--edit">
                        <str-textual-display class="str-about-description__description--edit-text" ...state.aboutEditDescription />
                    </span>
                    <textarea
                        value=descriptionText
                        on-input("handleTextUpdate")
                        disabled=profileEditState?.saving
                        maxlength=EDIT_MAX_LENGTH
                        rows=EDIT_ROWS
                        />
                    <span class="str-about-description--count">
                        ${descriptionText.length}/${EDIT_MAX_LENGTH}
                    </span>
                </div>
            </if>
            <else>
                <str-textual-display addLineBreaks=true class="str-about-description__description regular-text" ...state.about />
            </else>
        </div>
    </section>
    <section class="str-about-description__seller-info">
        <for|section| of=sections>
            $ {
                const title = get(section, "title", {});
                const action = get(section, "action", {});
            }
            <str-textual-display ...title action=action />
        </for>
    </section>
</div>
